__turbopack_context__.v({
  "image": "ItemThumbnail-module__O5fp_W__image",
});
